module.exports = __webpack_public_path__ + "static/media/shap1.f0e0fa6e.png";